let freeCoursePopupDialogElement: HTMLDialogElement;
let freeCoursePopupContentInitialised = false;

async function initPopupContent(dialog: HTMLDialogElement) {

	if (freeCoursePopupContentInitialised) {
		console.warn('Free course popup content already initialised');
		return;
	}
	freeCoursePopupContentInitialised = true;

	var form = {
		lang: null,
		course: null,
		step: 1,
	};

	var submitting = false;

	let coursesJson = await fetch('new-design/demo-courses-list.json');
	let courses: {[lang: string]: {name: string, id: number}[]} = {};
	if (coursesJson.ok) {
		courses = await coursesJson.json();
	} else {
		return;
	}

	var $selectLang = $('#demo-lang-select');
	var $selectCourse = $('#demo-course-select');

	$('#free-course-popup').find('.goto-step').click();

	form.lang = $selectLang.find('option').eq(0).val();

	function goToStep(step) {
		form.step = step;
		$('#free-course-popup').removeClass('demo-form--step1 demo-form--step2').addClass('demo-form--step' + step);
	}

	function rerenderSelectCourse() {
		form.lang = $selectLang.val();
		$selectCourse.html('');
		$.each(courses[form.lang], function(index, courseData) {
			$selectCourse.append(
				$('<option></option>').val(courseData.id).text(courseData.name)
			);
		})

		form.course = $selectCourse.find('option').eq(0).attr('value');
		$selectCourse.val(form.course);
		$('#demo-lang-icon').attr(
			'src',
			$('#demo-lang-icon').attr('data-srcpattern').replace(/%lang%/, form.lang)
		)
	}

	function updateSelectedCourse() {
		form.course = $selectCourse.val();
		$('#demo-course-cil').val(form.course);
	}

	function submit() {
		if (submitting) {
			return false;
		}
		submitting = true;
		var selectedCourse = courses[form.lang].find(function(c) {
			return +c.id === +form.course;
		});
		if (selectedCourse) {
			//dataLayer.push({event: 'Trial kurz', courseName: selectedCourse.name});
			// Nově pomocí GA4:
			if (dataLayer) {
				dataLayer.push({"event": "demo", course_id: selectedCourse.id + "", course_name: selectedCourse.name});
				console.log(JSON.stringify(dataLayer));
			}

			// Affilbox
			window.ab_instance = "partneri.onlinejazyky.cz";
			window.ab_kampan = 11;
			window.ab_cena = 0;
			window.ab_id_transakce = $('#demo-course-form').find('input[name="email"]').val();
			console.log('Affilbox conversion code inserted', window.ab_kampan, window.ab_id_transakce);
			$(document.head).append('<script src="https://partneri.onlinejazyky.cz/c3.js" type="text/javascript"></script>');
		}

		setTimeout(function() {
			$('#demo-course-form').submit();
		}, 800);

	}

	$('#free-course-popup').find('.goto-step[data-step]').click(function() {
		goToStep($(this).attr('data-step'));
	});

	$selectLang.change(function() {
		form.lang = $selectLang.val();
		rerenderSelectCourse();
		updateSelectedCourse();
	});

	$('#demo-course-submit').click(function() {
		submit();
	});

	$selectCourse.change(function() {
		updateSelectedCourse();
	});

	goToStep(1);
	rerenderSelectCourse();
	updateSelectedCourse();
	setTimeout(function() {
		rerenderSelectCourse();
		updateSelectedCourse();
	}, 200)






};

export function initFreeCoursePopup(dialog: HTMLDialogElement) {

	if (freeCoursePopupDialogElement) {
		console.warn('Free course popup already initialised');
		return;
	}

	let stylesheet = document.createElement('link');
	stylesheet.rel = 'stylesheet';
	stylesheet.href = 'css/homepage-demo-popup.css';
	document.head.appendChild(stylesheet);

	freeCoursePopupDialogElement = dialog;

	dialog.addEventListener('click', (e: MouseEvent) => {
		if (e.target && (e.target.nodeName === 'DIALOG' || e.target.matches('.free-course-popup__closer'))) {
			dialog.close();
		}
	})
}

export async function showFreeCoursePopup() {
	if (freeCoursePopupDialogElement) {

		if (!window['jQuery']) {
			await new Promise(
				(resolve) => {
					let s = document.createElement('script');
					s.src = 'js/jquery-1.10.2.min.js';
					s.onload = resolve;
					document.head.appendChild(s);
				}
			);
		}

		if (!freeCoursePopupContentInitialised) {
			initPopupContent(freeCoursePopupDialogElement);
		}

		freeCoursePopupDialogElement.showModal();
	}
}

// var that = this;
//
// var $buttons = $("a[href='" + this.linkTestForFree + "']");
//
// if ($buttons.length) {
// 	var $stylesheet = $('<link rel="stylesheet" type="text/css" href="css/homepage-demo-popup.css" />');
// 	$(document.head).append($stylesheet);
// }
//
// $buttons.each(function() {
// 	var node = $(this);
// 	//make sure it is not processed twice
// 	if (node.data("oj-initialized")) {
// 		return;
// 	}
// 	node.
// 	data("oj-initialized", true);
//
// 	node
// 		.attr("data-mfp-src", ".free-course-popup")
// 		.click(function(e) {
// 			//if (!that.isUserLogged()) {
// 			e.preventDefault();
// 			var n = $(this);
// 			//create node on demand
// 			that.createNodeTestForFree();
// 			that.initHomepageDemoPopupForm();
//
// 			var processed = n.data("oj-processed");
// 			//close menu
// 			that.getMenu().close();
//
// 			if (!processed) {
// 				n.magnificPopup({
// 					type:'inline',
// 					fixedContentPos: false,
// 					midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
// 					enableEscapeKey: true,
// 					closeMarkup: '<button title="Zavřít [Esc]" class="mfp-close ico-close">&#xf00d;</button>',
// 					mainClass: 'mfp-fade',
// 					callbacks: {
// 						open: function() {
// 							$(".oj-page-header").css("display", "none");
// 						},
// 						close: function() {
// 							// Will fire when popup is closed
// 							$(".oj-page-header").css("display", "block");
// 						}
// 					}
// 				});
// 				n.data("oj-processed", true);
// 				setTimeout(function() {
// 					n.trigger("click");
// 				}, 10);
// 			}
// 			//}
// 		});
// });
